export default __webpack_public_path__ + "static/media/sky.357f64e8.jpg";